import {useEffect, useState} from 'react'
import {KTSVG} from '../../../_metronic/helpers'
import {toast} from 'react-toastify'
import Swal from 'sweetalert2'
import './SuperAdminPermission.css'
import ReactPaginate from 'react-paginate'
import { Permission, PermissionPost, PermissionUpdate } from '../../models/SuperAdminPermission'
import PermissionService from '../../../api/super-admin/PermissionService'

interface Errors {
  title: string;
  key_name: string;
  details:string;
}

function SuperAdminPermission() {
  const initialOffset = 0
  const [showPopup, setShowPopup] = useState<boolean>(false);
  const [isEdit, setIsEdit] = useState<boolean>(false);
  const [offset, setOffset] = useState(initialOffset)
  const [PermissionList, setPermissionList] = useState<Permission[]>([] as Permission[]);
  const [allPermissionList, setAllPermissionList] = useState<Permission[]>([] as Permission[]);
  const [formData, setFormData] = useState<any>({ id: undefined, title: '', key_name:'', details:'' })
  const [formErrors, setFormErrors] = useState<Errors>({ title: '', key_name: '', details:'' });
  const [totalPages, setTotalPages] = useState<number>(0)
  const [limit, setLimit] = useState<number>(10)

  const [filteredTitleOptions, setFilteredTitleOptions] = useState<string[]>([]);
  const [showTitleOptions, setShowTitleOptions] = useState(false);

  const [filteredKeyNameOptions, setFilteredKeyNameOptions] = useState<string[]>([]);
  const [showKeyNameOptions, setShowKeyNameOptions] = useState(false);

  useEffect(() => {
    getPermissionList()
    getAllPermissionList()
  }, [])

  const getPermissionList = () => {
    let data: any = {
      limit: limit,
      offset: offset
    }
    PermissionService.getPermissionList(data).then(
      (res: any) => {
        if (res?.data?.success) {
          setPermissionList(res?.data?.data)
          setTotalPages(Math.ceil(res?.data?.total_count / limit))
        } else {
          setPermissionList([])
          setTotalPages(0)
        }
      },
      (err: any) => {
        toast.error(err?.response?.data?.message, {theme: 'dark'})
      }
    )
  }

  const getAllPermissionList = () => {  
    let data: any = {
      limit: 9999999999,
      offset: 0
    }
    PermissionService.getPermissionList(data).then(
      (res: any) => {
        if (res?.data?.success) {
          setAllPermissionList(res?.data?.data)
          // const titles = res?.data?.data.map((x: Permission) => x.title);      
          // setFilteredTitleOptions(titles);
          // const keyNames = res?.data?.data.map((x: Permission) => x.key_name);      
          // setFilteredKeyNameOptions(keyNames);
        } else {
          setAllPermissionList([])
          // setFilteredTitleOptions([]);
          // setFilteredKeyNameOptions([]);
          toast.error(res?.data?.message, {theme: 'dark'})
        }
      },
      (err: any) => {
        toast.error(err?.response?.data?.message, {theme: 'dark'})
      }
    )
  }

  const handlePageChange = (selected: any) => {
    const newOffset = selected === 0 ? 0 : selected * limit
    let data = {
      limit: limit,
      offset: newOffset,
    }
    PermissionService.getPermissionList(data).then(
      (res: any) => {
        if (res?.data?.success) {
          setPermissionList(res?.data?.data)
          setTotalPages(Math.ceil(res?.data?.total_count / limit))
          setOffset(newOffset);
        } else {
          setPermissionList([])
        }
      },
      (err: any) => {
        toast.error(err?.response?.data?.message, {theme: 'dark'})
      }
    )
  }

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    const {name, value} = e.target
    setFormData((prevFormData: any) => ({
      ...prevFormData,
      [name]: value,
    }))
  }

  const clearFormData = () => {
    setFormData({
      id: undefined,
      title: '',
      key_name:'',
      details:''
    })
  }

  const handleAdd = () => {
    clearFormData()
    setIsEdit(false)
    setShowPopup(true)
  }

  const handleEdit = (permission: Permission) => {
    setFormData({ id: permission.id, title: permission.title, key_name: permission.key_name, details: permission.details })
    setFilteredTitleOptions([permission.title])
    setFilteredKeyNameOptions([permission.key_name])
    setIsEdit(true);
    setShowPopup(true)
  }

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();

    // Clear previous errors
    setFormErrors({ title: '', key_name: '', details: '' });

    // Validation checks
    let errors: Errors = { title: '', key_name: '' , details:''};
    let hasErrors = false;
  
    if (!formData.title.trim()) {
      errors.title = 'Title is required';
      hasErrors = true;
    }
  
    if (!formData.key_name.trim()) {
      errors.key_name = 'Key Name is required';
      hasErrors = true;
    }
    if (!formData.details.trim()) {
      errors.details = 'Details is required';
      hasErrors = true;
    }
  
    if (hasErrors) {
      setFormErrors(errors);
      return;
    }    

    if (!isEdit) {      
      let data: PermissionPost = {
        title: formData?.title,
        key_name:formData?.key_name,
        details: formData?.details
      }
      
      PermissionService.addPermission(data).then(
        (res: any) => {
          if (res?.data?.success) {
            toast.success(res?.data?.message, {theme: 'dark'})            
            setShowPopup(false)
            clearFormData()
            getPermissionList()
            getAllPermissionList()
            setFilteredTitleOptions([])
            setFilteredKeyNameOptions([])
          } else {
            toast.error(res?.data?.message, {theme: 'dark'})
          }
        },
        (err: any) => {
          toast.error(err?.response?.data?.message, {theme: 'dark'})
        }
      )
    }
    else {
      let data: PermissionUpdate= {
        id: formData?.id!,
        title: formData?.title,
        key_name:formData?.key_name,
        details:formData?.details
      }
      PermissionService.updatePermission(data).then(
        (res: any) => {
          if (res?.data?.success) {
            toast.success(res?.data?.message, {theme: 'dark'})            
            setShowPopup(false)
            clearFormData()
            getPermissionList()
            getAllPermissionList()
            setFilteredTitleOptions([])
            setFilteredKeyNameOptions([])
          } else {
            toast.error(res?.data?.message, {theme: 'dark'})
          }
        },
        (err: any) => {
          toast.error(err?.response?.data?.message, {theme: 'dark'})
        }
      )
    }
  }

  const handleDelete = (id: number) => {
    Swal.fire({
      title: 'Are you sure?',
      text: 'Do you want to delete?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!',
    }).then((result: any) => {
      if (result.isConfirmed) {
        PermissionService.deletePermission(id).then(
          (res: any) => {
            if (res?.data?.success) {
              toast.success(res?.data?.message, {theme: 'dark'})
              getPermissionList()
            } else {
              toast.error(res?.data?.message, {theme: 'dark'})
            }
          },
          (err: any) => {
            toast.error(err?.response?.data?.message, {theme: 'dark'})
          }
        )
      }
    })
  }

  const handleStatusToggle = (id: number) => {
    Swal.fire({
      title: 'Are you sure?',
      text: 'Do you want to change the status?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, change it!',
    }).then((result: any) => {
      if (result.isConfirmed) {
        PermissionService.changePermission(id).then(
          (res: any) => {
            if (res?.data?.success) {
              toast.success(res?.data?.message, {theme: 'dark'})
              getPermissionList()
            } else {
              toast.error(res?.data?.message, {theme: 'dark'})
            }
          },
          (err: any) => {
            toast.error(err?.response?.data?.message, {theme: 'dark'})
          }
        )
      }
    })
  }

  const handleTitleInputChange = (event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    const value = event.target.value;
    setFormData((prevFormData: any) => ({
      ...prevFormData,
      title: value,
    }))

    const filtered = allPermissionList.filter(option =>
      value ? option.title.toLowerCase().includes(value.toLowerCase()) : false
    ).map(x => x.title);

    setFilteredTitleOptions(filtered);
    setShowTitleOptions(true);
  };

  const handleTitleOptionClick = (option: any) => {
    setFormData((prevFormData: any) => ({
      ...prevFormData,
      title: option,
    }))
    setShowTitleOptions(false);
  };

  const handleKeyNameInputChange = (event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    const value = event.target.value;
    setFormData((prevFormData: any) => ({
      ...prevFormData,
      key_name: value,
    }))

    const filtered = allPermissionList.filter(option =>
      value ? option.key_name.toLowerCase().includes(value.toLowerCase()) : false
    ).map(x => x.key_name);

    setFilteredKeyNameOptions(filtered);
    setShowKeyNameOptions(true);
  };

  const handleKeyNameOptionClick = (option: any) => {
    setFormData((prevFormData: any) => ({
      ...prevFormData,
      key_name: option,
    }))
    setShowKeyNameOptions(false);
  };

  return (
    <>  
      <div className='text-lg-end'>
        <button type='button' className='btn btn-primary px-5 py-3' onClick={handleAdd}>
          + Add Permission
        </button>
      </div>
      <div className='col-lg-12' style={{marginTop: 25}} />
      <div className='mb-5'>
        <div className='table-responsive'>
          <div className='d-flex justify-content-between w-100 p-3 pb-2'>
            <td className='d-flex w-lg-25'>
              <span className='text-dark fw-bold d-block fs-5 text-muted'>Title</span>
            </td>
            <td className='d-flex w-lg-25'>
              <span className='text-dark fw-bold d-block fs-5 text-muted'>Key Name</span>
            </td>
            <td className='d-flex w-lg-25'>
              <span className='text-dark fw-bold d-block fs-5 text-muted'>Details</span>
            </td>
            <td className='w-lg-25'>
              <span className='text-dark fw-bold d-block fs-5 text-muted'>Status</span>
            </td>
            <td className='text-end w-lg-25'>
              <span className='text-dark fw-bold d-block fs-5 text-muted'>Action</span>
            </td>
          </div>
          {PermissionList.map((permission: any, index: number) => (
            (permission.status === 1 || permission.status === 2) &&
            <div
              className='p-3 py-2 mb-2 bg-white d-flex justify-content-between w-100'
              key={index}
              style={{marginBottom: 20, borderRadius: 5}}
            >
              <td className='d-flex w-lg-25'>
                <span className='text-dark fw-bold d-block fs-5 d-flex align-items-center'>
                  {permission?.title?.length < 20 ? permission?.title : permission?.title?.substring(0,20)+' ...'}
                </span>
              </td>
              <td className='d-flex w-lg-25'>
                <span className='text-dark fw-bold d-block fs-5 d-flex align-items-center'>
                {permission?.key_name?.length < 20 ? permission?.key_name : permission?.key_name?.substring(0,20)+' ...'}
                </span>
              </td>
              <td className='d-flex w-lg-25'>
                <span className='text-dark fw-bold d-block fs-5 d-flex align-items-center'>
                {permission?.details?.length < 20 ? permission?.details : permission?.details?.substring(0,20)+' ...'}
                </span>
              </td>
              <td className='d-flex w-lg-25'>
                <span className={`fw-bold d-block fs-5 d-flex align-items-center ${permission.status===1? 'text-success' : 'text-danger'}`}>
                  {permission.status === 1 ? 'Active' : 'In-active'}
                </span>
              </td>
              <td className='d-flex justify-content-end w-lg-25'>
                <button
                  type='button'
                  onClick={() => handleEdit(permission)}
                  className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm mx-1'
                  data-bs-toggle='tooltip'
                  data-bs-placement='top'
                  title='Edit'
                >
                  <KTSVG path='/media/icons/duotune/art/art005.svg' className='svg-icon-3' />
                </button>
                <button
                  onClick={() => handleDelete(permission?.id)}
                  type='button'
                  className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm mx-1'
                  data-bs-toggle='tooltip'
                  data-bs-placement='top'
                  title='Delete'
                >
                  <KTSVG path='/media/icons/duotune/general/gen027.svg' className='svg-icon-3' />
                </button>
                <div className='d-flex justify-content-end flex-shrink-0 mx-1'>
                  {permission.status === 1 && (
                    <div className='d-flex align-items-center' data-bs-toggle='tooltip' data-bs-placement='top' title='Toggle Status'>
                      <button
                        className='status-holder active-status'
                        onClick={() => handleStatusToggle(permission.id)}
                      >
                        <div className='d-flex align-items-center justify-content-end'>
                          <div className='active-user active-status-light'></div>
                        </div>
                      </button>
                    </div>
                  )}
                  {permission.status === 2 && (
                    <div className='d-flex align-items-center' data-bs-toggle='tooltip' data-bs-placement='top' title='Toggle Status'>
                      <button
                        className='status-holder pending-status'
                        onClick={() => handleStatusToggle(permission.id)}
                      >
                        <div className='d-flex align-items-center'>
                          <div className='active-user pending-status-light'></div>
                        </div>
                      </button>
                    </div>
                  )}
                </div>
              </td>
            </div>
          ))}
        </div>
      </div>
      {totalPages > 0 && (
        <ReactPaginate
          previousLabel='Previous'
          nextLabel='Next'
          breakLabel='...'
          pageCount={totalPages}
          marginPagesDisplayed={2}
          pageRangeDisplayed={5}
          onPageChange={(selected) => handlePageChange(selected.selected)}
          containerClassName='pagination'
          activeClassName='active'
        />
      )}
      {showPopup && (
        <div className='modal' style={{display: 'block', backgroundColor: 'rgba(0, 0, 0, 0.5)'}}>
          <div className='modal-dialog modal-lg modal-dialog-centered'>
            <div className='modal-content'>
              <div className='modal-header'>
                <h5 className='modal-title'>{isEdit ? 'Update Permission' : 'Add Permission'}</h5>
                <button className='btn btn-close' onClick={() => {
                  setFormErrors({ title: '', key_name: '', details:'' })
                  setShowPopup(false)
                  setFilteredTitleOptions([])
                  setFilteredKeyNameOptions([])
                }}></button>
              </div>
              <div className='modal-body users'>
                {/* Form */}
                <form onSubmit={handleSubmit}>
                  {/* <div className='row mb-3'>
                    <div className='form-group col'>
                      <label htmlFor='title'>Title</label>
                      <input
                        type='text'
                        id='title'
                        name='title'
                        className={`form-control ${formErrors.title && 'is-invalid'}`}
                        value={formData.title}
                        onChange={handleInputChange}
                      />
                      {formErrors.title && <div className='invalid-feedback'>{formErrors.title}</div>}
                    </div>
                  </div> */}
                  <div className='row mb-3'>
                    <div className='form-group col'>
                      <label htmlFor='title'>Title</label>
                      <div className="searchable-dropdown">
                        <input
                          type="text"
                          value={formData.title}
                          onChange={handleTitleInputChange}
                          onFocus={() => setShowTitleOptions(true)}
                          onBlur={() => setTimeout(() => setShowTitleOptions(false), 100)} // Delay to allow click event to register
                          className={`form-control ${formErrors.title && 'is-invalid'}`}
                        />
                        {showTitleOptions && (
                          <ul className="options">
                            {filteredTitleOptions.length > 0 ? (
                              filteredTitleOptions.map((option, index) => (
                                <li key={index} onClick={() => handleTitleOptionClick(option)}>
                                  {option}
                                </li>
                              ))
                            ) : (
                              <li>No results found</li>
                            )}
                          </ul>
                        )}
                      </div>
                      {formErrors.title && <div style={{color: '#B53743', fontSize: '12px', marginTop: '5px'}}>{formErrors.title}</div>}
                    </div>
                  </div>
                  <div className='row mb-3'>
                    <div className='form-group col'>
                      <label htmlFor='key_name'>Key Name</label>
                      <div className="searchable-dropdown">
                        <input
                          type="text"
                          value={formData.key_name}
                          onChange={handleKeyNameInputChange}
                          onFocus={() => setShowKeyNameOptions(true)}
                          onBlur={() => setTimeout(() => setShowKeyNameOptions(false), 100)} // Delay to allow click event to register
                          className={`form-control ${formErrors.key_name && 'is-invalid'}`}
                        />
                        {showKeyNameOptions && (
                          <ul className="options">
                            {filteredKeyNameOptions.length > 0 ? (
                              filteredKeyNameOptions.map((option, index) => (
                                <li key={index} onClick={() => handleKeyNameOptionClick(option)}>
                                  {option}
                                </li>
                              ))
                            ) : (
                              <li>No results found</li>
                            )}
                          </ul>
                        )}
                      </div>
                       {formErrors.key_name && <div style={{color: '#B53743', fontSize: '12px', marginTop: '5px'}}>{formErrors.key_name}</div>}
                    </div>
                  </div>
                  <div className='row mb-3'>
                    <div className='form-group col'>
                      <label htmlFor='details'>Details</label>
                      <input
                        type='text'
                        id='details'
                        name='details'
                        className={`form-control ${formErrors.details && 'is-invalid'}`}
                        value={formData.details}
                        onChange={handleInputChange}
                      />
                       {formErrors.details && <div style={{color: '#B53743', fontSize: '12px', marginTop: '5px'}}>{formErrors.details}</div>}
                    </div>
                  </div>
                  <div className='text-end'>
                    <button type='submit' className='btn btn-primary' style={{borderRadius: 25}}>
                    {isEdit ? 'Update' : 'Add'}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export default SuperAdminPermission
